import * as React from 'react'
import { type BrandTracking } from './brand/types'
import { type ProjectTracking } from './project/types'
import { type SocialTracking } from './social/types'
import { type TransactionTracking } from './transaction/types'
import { type EcommerceTracking } from './ecommerce/types'
import { tracking } from './base/tracking'
import { type LeadTracking } from './lead/types'
import { tracking as brandTracking } from './brand/tracking'
import { tracking as socialTracking } from './social/tracking'
import { tracking as projectTracking } from './project/tracking'
import { tracking as transactionTracking } from './transaction/tracking'
import { tracking as ecommerceTracking } from './ecommerce/tracking'
import { tracking as leadTracking } from './lead/tracking'

import { type Tracking } from './base/types'
import { safePusher } from './safePush'

export type TrackingContext = Tracking & {
  brand: BrandTracking
  lead: LeadTracking
  project: ProjectTracking
  social: SocialTracking
  transaction: TransactionTracking
  ecommerce: EcommerceTracking
}

export const trackingContext = React.createContext<TrackingContext>({
  ...tracking(safePusher()),
  brand: brandTracking(safePusher()),
  lead: leadTracking(safePusher()),
  social: socialTracking(safePusher()),
  project: projectTracking(safePusher()),
  transaction: transactionTracking(safePusher()),
  ecommerce: ecommerceTracking(safePusher()),
})
